export default "__VITE_ASSET__Mlq_AGFL__"